export enum AiTierLevel {
  FREE = 'FREE',
  MEDIUM = 'MEDIUM',
  UNLIMITED = 'UNLIMITED',
}

export enum PendingChangeVariant {
  DOWNGRADE = 'downgrade',
  CANCELLATION = 'cancellation',
}

export type PendingChange = {
  variant: PendingChangeVariant;
  effectiveDate: Date;
  targetTier: {
    targetTierLevel: AiTierLevel;
    targetTierName: string;
  };
};

export type TokenAccount = {
  availableMonthlyTokens: number;
  availableDailyTokens: number;
  currentTier: AiTierLevel;
  nextResetDate: Date;
  pendingChange: PendingChange | null;
};

export type AiSubscriptionProduct = {
  id: string;
  name: string;
  monthlyTokens: number;
  priceInEuro: number;
  description: string;
  tier: AiTierLevel;
  actionType: AiSubscriptionActionType;
};

export enum AiSubscriptionActionType {
  UPGRADE = 'upgrade',
  DOWNGRADE = 'downgrade',
  CURRENT = 'current',
}

export interface TokenTierConfig {
  id: string;
  tier: AiTierLevel;
  monthlyTokens: number;
  dailyTokensLimit: number | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface TokenTransaction {
  id: string;
  userId: string;
  type: 'CONSUMED' | 'GRANTED' | 'REFUNDED';
  amount: number;
  balanceBefore: number;
  balanceAfter: number;
  worksheetId?: string;
  jobId?: string;
  reason: string;
  metadata?: any;
  createdAt: string;
  worksheet?: {
    id: string;
    title: string;
  };
  job?: {
    id: string;
    status: string;
  };
}

export interface SubscriptionEvent {
  id: string;
  userId: string;
  eventType: string;
  oldTier?: AiTierLevel;
  newTier?: AiTierLevel;
  oldMonthlyTokens?: number;
  newMonthlyTokens?: number;
  oldDailyLimit?: number;
  newDailyLimit?: number;
  reason?: string;
  metadata?: any;
  createdAt: string;
}

export interface AiSubscriptionManageRequest {
  returnUrl: string;
}

export interface AiSubscriptionManageResponse {
  portalUrl: string;
  portalId: string;
}

export interface AiSubscriptionCheckoutRequest {
  tierId: string;
  successUrl: string;
  cancelUrl: string;
  portalReturnUrl: string;
}
export interface AiSubscriptionCheckoutResponse {
  checkoutUrl: string;
  sessionId: string;
}
